import { Component, h, Prop, Element } from '@stencil/core';
import { heroShadowSVG } from '../aafp-hero/hero-shadow';
/**
 * COMPNAME is for creating a presentational component for article pages.
 *
 * <em>For More Information:</em>
 * AEM Component- aafp-aem-library.git/ui.apps/src/main/content/jcr_root/apps/brand/aafp/components/content/aafp-detailed-content-hero
 * Sling Model- core.src.main.java.org.aafp.aem.core.models.AafpDetailedContentHeroModel.java
 */
@Component({
  tag: 'aafp-detailed-content-hero',
  shadow: false,
})
export class AafpDetailedContentHero {
  /**
   * For storing Article Date asset
   */
  @Prop() date: string;
  /**
   * For storing Text asset
   */
  @Prop() heroText!: string;
  /**
   * For storing Title asset
   */
  @Prop() heroTitle!: string;
  /**
   * For storing Author Name asset
   */
  @Prop() authorName: string;
  /**
   * For storing Author's Title asset
   */
  @Prop() authorTitle: string;
  /**
   * For storing the URL of the image asset
   */
  @Prop() imgSrc!: string;
  /**
   * For storing the Image Alt Description asset
   */
  @Prop() imgAlt!: string;

  @Element() element: HTMLElement;

  renderImage() {
    return (
      <div class="adl-detailed-content-hero__img-wrapper">
        <div class="adl-detailed-content-hero__img-border">
          <img class="adl-detailed-content-hero__img" src={this.imgSrc} alt={this.imgAlt} />
        </div>
        <div class="adl-detailed-content-hero__img-shadow" innerHTML={heroShadowSVG}></div>
        {this.authorName && <div class="adl-detailed-content-hero__author">By {this.authorName}</div>}
        {this.authorTitle && <div class="adl-detailed-content-hero__author-title adl-body">{this.authorTitle}</div>}
      </div>
    );
  }

  render() {
    return (
      <div class="adl-detailed-content-hero adl-background-color--lightest">
        <div class="adl-detailed-content-hero__inner-wrapper">
          <div class="adl-detailed-content-hero__title-wrapper">
            <div class="adl-detailed-content-hero__title adl-h1" innerHTML={this.heroTitle} />
            <div class="adl-detailed-content-hero__text adl-h3" innerHTML={this.heroText} />
            {this.date && <div class="adl-detailed-content-hero__date adl-body">{this.date}</div>}
            <div class="adl-detailed-content-hero__social-icons">
              <slot name="social-icons"></slot>
            </div>
          </div>
          {this.imgSrc && this.renderImage()}
        </div>
      </div>
    );
  }
}
